import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { playerSearchParams } from './format';

// A player ID search lives in the URL (?user_id=123) so it can be shared as a link.
// Email searches stay out of the URL.
const USER_ID_KEY = 'user_id';

const userIdOf = (player) => playerSearchParams(player).user_id || '';

// playerFromSearch reads the player ID from the URL query.
export const playerFromSearch = (searchParams) => userIdOf(searchParams.get(USER_ID_KEY));

// searchWithPlayer returns a copy of the query holding the player's ID, or none for an email
// or empty search; other params stay.
export const searchWithPlayer = (searchParams, player) => {
  const next = new URLSearchParams(searchParams);
  next.delete(USER_ID_KEY);
  const userId = userIdOf(player);
  if (userId) next.set(USER_ID_KEY, userId);
  return next;
};

// usePlayerParam is useState for the Player search box, with player IDs mirrored to the URL.
export function usePlayerParam() {
  const [searchParams, setSearchParams] = useSearchParams();
  const urlUserId = playerFromSearch(searchParams);
  const [player, setPlayerState] = useState(urlUserId);

  // Follow URL changes made outside the box (a pasted link, back/forward, the sidebar link),
  // keeping an email search that the URL does not hold.
  useEffect(() => {
    setPlayerState((p) => (userIdOf(p) === urlUserId ? p : urlUserId));
  }, [urlUserId]);

  const setPlayer = useCallback((text) => {
    setPlayerState(text);
    setSearchParams((sp) => searchWithPlayer(sp, text), { replace: true });
  }, [setSearchParams]);

  return [player, setPlayer];
}
